import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Img from 'react-bootstrap/Image';
import { sendPasswordResetLink } from '../services/authService';
import { showError, showSuccess } from '../utils/toast';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      showError('Please enter your email address.');
      return;
    }

    setLoading(true);
    try {
      await sendPasswordResetLink(email.trim());
      setSubmitted(true);
      showSuccess('If an account exists, a reset link has been sent to your email.');
    } catch (error) {
      showError(error.message || 'Unable to send reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hr-login-page">
      <Form onSubmit={handleSubmit} className="hr-login-card">
        <div className="text-center mb-4">
          <Img src="./Images/LOGO_ORNNOVA.avif" style={{ width: '200px' }} alt="Ornnova logo" />
          <h4 className="mt-3 mb-1">Forgot Password</h4>
          <p className="text-muted mb-0">Enter your email to receive a reset link</p>
        </div>
        <hr />

        {submitted ? (
          <div className="text-center">
            <p className="mb-3">
              Check your inbox for the password reset link. The link is valid for 1 hour.
            </p>
            <Link to="/" className="hr-login-link">Back to Sign In</Link>
          </div>
        ) : (
          <>
            <Form.Group className="mb-3" controlId="forgotEmail">
              <Form.Label><b>Email address</b></Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your registered email"
                required
              />
            </Form.Group>

            <div className="text-center d-grid gap-2">
              <Button className="hr-btn-accent px-4" type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
              <Link to="/" className="hr-login-link">Back to Sign In</Link>
            </div>
          </>
        )}
      </Form>
    </div>
  );
}

export default ForgotPassword;
